import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface AdminAnalyticsKpis {
  totalUsers: number;
  activeUsers: number;
  totalTangrams: number;
  tangramsViewed: number;
  avgCompletionRate: number;
  avgRating: number;
}

export interface AdminAnalyticsContentType {
  type: string;
  count: number;
  avgCompletion: number;
  avgRating: number;
}

export interface AdminAnalyticsFeature {
  feature: string;
  uses: number;
  uniqueUsers: number;
  utilizationPct: number;
}

interface ApiResponse<T> { success: boolean; data: T; }

export type AnalyticsPeriod = 'week' | 'month' | 'term' | 'all';

@Injectable({ providedIn: 'root' })
export class AdminAnalyticsService {
  private readonly baseUrl = `${environment.baseUrl}/admin/analytics`;

  constructor(private http: HttpClient) {}

  private params(period: AnalyticsPeriod): HttpParams {
    return new HttpParams().set('period', period);
  }

  getKpis(period: AnalyticsPeriod): Observable<ApiResponse<AdminAnalyticsKpis>> {
    return this.http.get<ApiResponse<AdminAnalyticsKpis>>(`${this.baseUrl}/kpis`, { params: this.params(period) });
  }

  getContentTypes(period: AnalyticsPeriod): Observable<ApiResponse<AdminAnalyticsContentType[]>> {
    return this.http.get<ApiResponse<AdminAnalyticsContentType[]>>(`${this.baseUrl}/content-types`, { params: this.params(period) });
  }

  getFeatures(period: AnalyticsPeriod): Observable<ApiResponse<AdminAnalyticsFeature[]>> {
    return this.http.get<ApiResponse<AdminAnalyticsFeature[]>>(`${this.baseUrl}/features`, { params: this.params(period) });
  }
}
